import {
  LastUsedInfoConnected as LastUsedInfo,
  INFO_TYPES,
} from './lastUsedInfo'

export { LastUsedInfo, INFO_TYPES }
